/*LIBRARY*/
import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import io from "socket.io-client";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import EditLayer from "./EditLayer";
import DeleteLayer from "./DeleteLayer";
import DeleteLayerAttach from "./DeleteLayerAttach";
import AddRowBulk from "./AddRowBulk";

/*REDUX*/
import {
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setLayerWOgeojson,
  setChatStatus,
  set_value_layer,
} from "../../App/actions/layerActions";
import { migration_action } from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { get_pda, get_pch } from "../../App/actions/iotActions";
import { get_layer_detail_custom_api } from "../../App/actions/openApiActions";
import {
  view_layer,
  set_layer_id,
  view_heatmap,
} from "../../App/actions/dataActions";
import { set_value_toolbox } from "../../App/actions/toolboxActions";
import { openModal } from "../../App/actions/authActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";
import ICON_TABLE from "../../Assets/jsx/ICON_TABLE";
import ICON_GEOMETRY from "../../Assets/jsx/ICON_GEOMETRY";
import ICON_HEATMAP from "../../Assets/jsx/ICON_HEATMAP";
import ICON_CHAT from "../../Assets/jsx/ICON_CHAT";
import EditIcon from "../common_icon/EditIcon";
import DeleteIcon from "../common_icon/DeleteIcon";
import pic_static from "../../Assets/svg/profile_pic_comment.svg";
import CIRCLE from "../../Assets/jsx/CIRCLE";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const sidebar_closed = 70;
const SOCKET_URL_MAPID = "https://socket.mapid.io";
const geo_layer_status_that_editable_properties = [
  "original",
  "digitasi",
  "upload",
  "site_selection",
  "SS_MANUAL",
];
const geo_layer_status_that_editable_layer = [
  "original",
  "digitasi",
  "upload",
  "attached",
  "site_selection",
  "SS_MANUAL",
];
const geo_layer_status_that_deleteable = [
  "original",
  "digitasi",
  "upload",
  "attached",
  "site_selection",
  "SS_MANUAL",
];

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const LayerListRender = ({
  auth,
  layer,
  project,
  properties,
  checkedLayers,
  geo_layer_list,
  is_mode_checklist_layer,
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setLayerWOgeojson,
  setChatStatus,
  getDetailLayerById,
  view_layer,
  set_layer_id,
  view_heatmap,
  migration_action,
  set_value_layer,
  get_pda,
  get_pch,
  get_layer_detail_custom_api,
  set_value_toolbox,
  set_value_properties,
  setCheckedLayers,
}) => {
  /*STATE*/
  const [modal_bounding_box, set_modal_bounding_box] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalDeleteAttach, setModalDeleteAttach] = useState(false);
  const [modalMigration, setModalMigration] = useState(false);
  const [modalEditorInfo, setModalEditorInfo] = useState(false);
  const [modalEditorData, setModalEditorData] = useState(null);
  const [bodyMigrate, setBodyMigrate] = useState({
    geo_layer_id: "",
    user_id: "",
    geo_project_id: "",
  });
  const [editorUsers] = useState([]);
  const [modal_wait_get_layer, set_modal_wait_get_layer] = useState(false);

  const socket = useRef(null);

  useEffect(() => {
    socket.current = io.connect(SOCKET_URL_MAPID, {
      secure: true,
      reconnection: true,
      rejectUnauthorized: false,
    });

    const handleBeforeUnload = () => {
      const { _id, name, email, profile_picture } = auth?.user || {};
      const user_data = { _id, name, email, profile_picture };
      socket.current.emit("from_mapid_backend", {
        data: { ...user_data },
        topic: "userDeleteAllLayer",
      });
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (socket.current) {
        socket.current.disconnect();
      }
    };
  }, [auth.user]);

  // NEW LOGIC: Auto close modal_wait_get_layer after 3 seconds
  useEffect(() => {
    let timer;
    if (modal_wait_get_layer) {
      timer = setTimeout(() => {
        set_modal_wait_get_layer(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [modal_wait_get_layer]);

  /*METHODS*/
  const toggle_wait_get_layer = () => {
    set_modal_wait_get_layer(!modal_wait_get_layer);
  };

  const toggle_bounding_box = () => {
    set_modal_bounding_box(!modal_bounding_box);
  };

  const handleModalEditorUser = (user) => {
    setModalEditorInfo(!modalEditorInfo);
    setModalEditorData(user || null);
  };

  const handle_unsubscribe_socket = (user, layerId) => {
    socket.current.emit("from_mapid_backend", {
      data: { ...user, idLayer: layerId },
      topic: "userDelete",
    });
    socket.current.off(`${layerId}`);
  };

  const handle_subscribe_socket = (user, layerId) => {
    socket.current.emit("from_mapid_backend", {
      data: { ...user, idLayer: layerId, borderColor: getRandomColor() },
      topic: "userUpdate",
    });
  };

  const handle_pre_subscribe_socket = (dataId) => {
    const { _id, name, full_name, email, profile_picture } = auth?.user || {};
    const user_data = {
      _id,
      name,
      full_name,
      email,
      profile_picture,
    };
    handle_subscribe_socket(user_data, dataId);
  };

  const handle_pre_delete_viewer = (dataId) => {
    const { _id, name, email, profile_picture } = auth?.user || {};
    const user_data = {
      _id,
      name,
      email,
      profile_picture,
    };
    handle_unsubscribe_socket(user_data, dataId);
  };

  const disable_geometry = () => {
    const { map_object, draw_object } = layer;
    setEditGeometry(false);
    set_value_layer({
      key: "draw_state_platform",
      value: "",
    });
    if (map_object?.getCanvas()?.style?.cursor) {
      map_object.getCanvas().style.cursor = ""; //reset cursor
    }
    if (draw_object) {
      draw_object?.changeMode("simple_select");
      draw_object?.deleteAll();
    }
    set_value_layer({
      key: "draw_active",
      value: false,
    });
  };

  const on_fly_layer = (geo_layer_item, folder_id) => {
    disable_geometry();
    set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom, layer_id, loadingProcess } = layer;
    if (popup_dom) {
      popup_dom.remove();
      set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = layer;
      const body = { geo_layer_id: geo_layer_item._id, value: true };
      view_layer(body);
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        layer_id_bound.push(geo_layer_item?._id);
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
        set_modal_bounding_box(true);
      } else {
        layer_id_bound = layer_id_bound.filter(
          (item) => item !== geo_layer_item?._id,
        );
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (layer_id !== geo_layer_item._id) {
        if (
          geo_layer_item?.geojson?.features?.length === 0 ||
          !geo_layer_item?.geojson?.features
        ) {
          if (loadingProcess) {
            set_modal_wait_get_layer(true);
          } else {
            if (geo_layer_item?.type_2 === "pch") {
              get_pch(geo_layer_item);
            } else if (geo_layer_item?.type_2 === "pda") {
              get_pda(geo_layer_item);
            } else {
              if (geo_layer_item?.is_custom_endpoint) {
                get_layer_detail_custom_api(geo_layer_item._id);
              } else {
                const { geo_project } = project;
                const body = {
                  geo_layer_id: geo_layer_item._id,
                  geo_project_id: geo_project._id,
                  flyStatus: true,
                  folder_id,
                  capex_value: properties.capex_value,
                  geo_layer_item,
                };
                getDetailLayerById(body);
              }
            }
          }
        } else {
          set_layer_id(geo_layer_item._id);
          const body = { geo_layer_id: geo_layer_item._id, value: true };
          view_layer(body);
        }
      } else {
        set_layer_id("");
      }
    }
  };

  const on_view_layer = (geo_layer_item, value, folder_id) => {
    disable_geometry();

    set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom, layer_id, loadingProcess } = layer;
    if (popup_dom) {
      popup_dom.remove();
      set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const { geo_project } = project;

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = layer;
      const body = { geo_layer_id: geo_layer_item._id, value };
      view_layer(body);
      if (value === true) {
        layer_id_bound.push(geo_layer_item?._id);
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
        set_modal_bounding_box(true);
      } else {
        layer_id_bound = layer_id_bound.filter(
          (item) => item !== geo_layer_item?._id,
        );
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (
        (layer_id !== geo_layer_item?._id &&
          geo_layer_item?.geojson?.features?.length === 0) ||
        !geo_layer_item?.geojson?.features
      ) {
        if (loadingProcess) {
          set_modal_wait_get_layer(true);
        } else {
          if (geo_layer_item?.type_2 === "pch") {
            get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                flyStatus: true,
                folder_id,
                capex_value: properties.capex_value,
                geo_layer_item,
              };
              getDetailLayerById(body);
            }
          }
        }
      } else {
        const body = { geo_layer_id: geo_layer_item._id, value };
        view_layer(body);
      }
      if (value) {
        handle_pre_subscribe_socket(geo_layer_item._id);
      } else {
        handle_pre_delete_viewer(geo_layer_item._id);
      }
    }
  };

  const on_view_heatmap = (geo_layer_item, value, folder_id) => {
    disable_geometry();

    set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom, layer_id, loadingProcess, map_object } = layer;
    if (popup_dom) {
      popup_dom.remove();
      set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = layer;
      const body = { geo_layer_id: geo_layer_item._id, value };
      view_layer(body);
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        layer_id_bound.push(geo_layer_item?._id);
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
        set_modal_bounding_box(true);
      } else {
        layer_id_bound = layer_id_bound.filter(
          (item) => item !== geo_layer_item?._id,
        );
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (
        (layer_id !== geo_layer_item?._id &&
          geo_layer_item?.geojson?.features?.length === 0) ||
        !geo_layer_item?.geojson?.features
      ) {
        if (loadingProcess) {
          set_modal_wait_get_layer(true);
        } else {
          if (geo_layer_item?.type_2 === "pch") {
            get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const { geo_project } = project;
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                flyStatus: true,
                folder_id,
                capex_value: properties.capex_value,
                geo_layer_item,
              };
              getDetailLayerById(body);
            }
          }
        }
      } else {
        const body = { geo_layer_id: geo_layer_item._id, value };
        view_heatmap(body);
      }
      if (value === false) {
        const layer_id_heatmap_str = `heatmap_${geo_layer_item?._id}`;
        if (map_object.getLayer(layer_id_heatmap_str)) {
          map_object.removeLayer(layer_id_heatmap_str);
        }
        if (map_object.getSource(layer_id_heatmap_str)) {
          map_object.removeSource(layer_id_heatmap_str);
        }
      }
    }
  };

  const toggle_edit_geometry = (geo_layer_item, folder_id) => {
    set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const {
      popup_dom,
      geometryStatus,
      layer_id,
      map_object,
      draw_object,
      loadingProcess,
    } = layer;
    if (popup_dom) {
      popup_dom.remove();
      set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const { geo_project } = project;
    if (!geometryStatus) {
      const { type, architecture } = geo_layer_item;
      set_value_layer({
        key: "current_architecture",
        value: architecture,
      });
      set_value_layer({
        key: "current_type",
        value: type,
      });
      set_value_toolbox({
        key: "mode_draw",
        value: "simple_select",
      });
      handle_pre_subscribe_socket(geo_layer_item._id);
      set_value_layer({
        key: "draw_state_platform",
        value: "geometry",
      });
      const geojson = geo_layer_item?.geojson || {
        type: "FeatureCollection",
        features: [],
      };

      if (draw_object) {
        draw_object?.[1]?.add(geojson);
        draw_object?.[1]?.changeMode("simple_select");
      }

      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }
    } else {
      set_value_layer({
        key: "draw_state_platform",
        value: "",
      });
      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }

      if (draw_object) {
        draw_object?.changeMode("simple_select");
        draw_object?.deleteAll();
      }
    }

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = layer;
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        const body = { geo_layer_id: geo_layer_item._id, value: true };
        view_layer(body);
        set_modal_bounding_box(true);
        layer_id_bound.push(geo_layer_item?._id);
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (layer_id !== geo_layer_item._id) {
        if (!geo_layer_item?.geojson?.features?.length) {
          if (loadingProcess) {
            set_modal_wait_get_layer(true);
          } else {
            if (geo_layer_item?.type_2 === "pch") {
              get_pch(geo_layer_item);
            } else if (geo_layer_item?.type_2 === "pda") {
              get_pda(geo_layer_item);
            } else {
              if (geo_layer_item?.is_custom_endpoint) {
                get_layer_detail_custom_api(geo_layer_item._id);
              } else {
                const body = {
                  geo_layer_id: geo_layer_item._id,
                  geo_project_id: geo_project._id,
                  flyStatus: true,
                  folder_id,
                  capex_value: properties.capex_value,
                  geo_layer_item,
                };
                getDetailLayerById(body);
              }
            }
          }
          handle_pre_subscribe_socket(geo_layer_item._id);
        } else {
          set_layer_id(geo_layer_item._id);
          setEditGeometry(!geometryStatus);
        }
      } else {
        if (!geo_layer_item?.geojson?.features?.length) {
          if (loadingProcess) {
            set_modal_wait_get_layer(true);
          } else {
            const body = {
              geo_layer_id: geo_layer_item._id,
              geo_project_id: geo_project._id,
              folder_id,
              capex_value: properties.capex_value,
              geometryStatus: !geometryStatus,
              geo_layer_item,
            };
            getDetailLayerById(body);
            handle_pre_subscribe_socket(geo_layer_item._id);
          }
        } else {
          set_layer_id(geo_layer_item._id);
          setEditGeometry(!geometryStatus);
        }
      }
    }
  };

  const toggle_edit_property = (geo_layer_item, folder_id) => {
    disable_geometry();

    const { is_mobile } = properties;
    if (is_mobile) {
      set_value_properties({
        key: "sidebar_left_status",
        value: false,
      });
      set_value_properties({
        key: "is_mobile_close",
        value: true,
      });
      set_value_properties({
        key: "sidebar_height",
        value: sidebar_closed,
      });
    }

    set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom, tableStatus, layer_id, loadingProcess } = layer;
    if (popup_dom) {
      popup_dom.remove();
      set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const is_active_layer = layer_id === geo_layer_item._id;
    const is_geojson_empty =
      !geo_layer_item?.geojson?.features ||
      geo_layer_item?.geojson?.features?.length === 0;

    setTabelStatus(is_active_layer ? !tableStatus : true);

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = layer;
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        const body = { geo_layer_id: geo_layer_item._id, value: true };
        view_layer(body);
        set_modal_bounding_box(true);
        layer_id_bound.push(geo_layer_item?._id);
        set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (is_geojson_empty) {
        if (loadingProcess) {
          set_modal_wait_get_layer(true);
        } else {
          if (geo_layer_item?.type_2 === "pch") {
            get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const { geo_project } = project;
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                flyStatus: true,
                folder_id,
                capex_value: properties.capex_value,
                geo_layer_item,
              };
              getDetailLayerById(body);
            }
          }
        }
      }
    }

    set_value_layer({
      key: "sorted_by",
      value: [
        {
          field: "id",
          sort: "asc",
        },
      ],
    });

    if (!is_active_layer || !tableStatus) {
      set_layer_id(geo_layer_item._id);
      handle_pre_subscribe_socket(geo_layer_item._id);
    }
  };

  const toggle_chat_on_layer = (geo_layer_item) => {
    disable_geometry();

    set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom, geo_layer_wo_geojson, chatStatus } = layer;
    if (popup_dom) {
      popup_dom.remove();
      set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const current_layer_wo = geo_layer_wo_geojson?.geo_layer;
    if (current_layer_wo?._id !== geo_layer_item?._id) {
      const content = {
        geo_layer: geo_layer_item,
      };
      setLayerWOgeojson(content);
      setChatStatus(true);
    } else {
      const content = {
        geo_layer: geo_layer_item,
      };
      setLayerWOgeojson(content);
      setChatStatus(!chatStatus);
    }
  };

  const toggle_edit_general = (geo_layer_item) => {
    disable_geometry();
    setModalEdit(!modalEdit);
    if (geo_layer_item) {
      const content = {
        geo_layer: geo_layer_item,
      };
      setLayer(content);
    }
  };

  const toggle_delete_layer = (geo_layer_item) => {
    disable_geometry();
    if (geo_layer_item) {
      const content = {
        geo_layer: geo_layer_item,
      };
      setLayer(content);
    }
    setModalDelete(!modalDelete);
  };

  const toggle_delete_attached_layer = (geo_layer_item) => {
    disable_geometry();
    if (geo_layer_item) {
      const content = {
        geo_layer: geo_layer_item,
      };
      setLayer(content);
    }
    setModalDeleteAttach(!modalDeleteAttach);
  };

  const handleCheckMarkLayers = (id) => {
    if (id) {
      let updatedCheckedLayers = [...checkedLayers];
      const findResult = updatedCheckedLayers.findIndex(
        (layerId) => layerId === id,
      );
      if (findResult !== -1) {
        updatedCheckedLayers = updatedCheckedLayers.filter(
          (layerId) => layerId !== id,
        );
      } else {
        updatedCheckedLayers.push(id);
      }
      setCheckedLayers(updatedCheckedLayers);
    }
  };

  const isIdInsideChecklistLayers = (id) => {
    return !!checkedLayers.find((layerId) => layerId === id);
  };

  const toggleModalMigration = () => {
    setModalMigration(!modalMigration);
  };

  const migration = async () => {
    await migration_action(bodyMigrate);
  };

  /*RENDER LOGIC*/
  const language = localStorage?.language || auth.language;
  let mode_list = localStorage?.mode_list;

  const {
    geo_layer_wo_geojson,
    geometryStatus,
    tableStatus,
    flyStatus,
    chatStatus,
    layer_id,
    layer_id_active,
    layer_id_heatmap,
  } = layer;
  const domain = auth.domain;
  const { mode_map } = properties;

  const modal_bounding_box_content = modal_bounding_box && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modal_bounding_box}
      onClose={toggle_bounding_box}
    >
      <div className="box-body">
        <main className="text_center">
          <p className="text_bold margin_bottom">
            {
              dict?.[
                "This layer uses get data by bounding box, zoom and pan the map to load data"
              ]?.[language]
            }
          </p>
          <img
            src="https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/public/bounding_box.gif"
            alt="Bounding Box"
            style={{ width: "500px", maxWidth: "100%", borderRadius: "7px" }}
          />
        </main>
      </div>
    </Modal>
  );

  const modal_wait_get_layer_content = modal_wait_get_layer && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_wait_get_layer}
      onClose={toggle_wait_get_layer}
    >
      <div className="box-body">
        <main className="text_center">
          <p className="text_big">Tunggu data sebelumnya termuat</p>
        </main>
      </div>
    </Modal>
  );

  if (!mode_list) {
    if (
      ["bbwsciliwungcisadane.mapid.io", "bbwsbrantas.mapid.io"].includes(domain)
    ) {
      mode_list = "compact";
    } else {
      mode_list = "default";
    }
  }

  const list_content = (
    <main>
      {geo_layer_list.map((layer_item, idx) => {
        const folder_id = layer_item?.folder || "";
        const status = layer_item?.status;
        const geo_layer = layer_item?.geo_layer;
        const { _id, name, user, architecture, geo_project } = geo_layer || {};
        const { full_name, badge } = user || {};
        const viewStatus = layer_id_active.includes(geo_layer?._id);
        const is_view_heatmap = layer_id_heatmap.includes(geo_layer?._id);
        const username = user?.name;

        let id_css =
          _id === layer_id && flyStatus ? "box_active" : "box_non_active";

        const addRowBulkButton = (
          <div style={{ display: "inline-block", marginRight: "5px" }}>
            <AddRowBulk geo_layer={geo_layer} />
          </div>
        );

        const editLayerButton = (
          <div
            onClick={() => toggle_edit_general(geo_layer)}
            style={{ display: "inline-block" }}
            data-mapid={`clickEdit-${idx}`}
          >
            <EditIcon />
          </div>
        );

        const deleteLayerButton = (
          <div
            onClick={() =>
              status === "attached"
                ? toggle_delete_attached_layer(geo_layer)
                : toggle_delete_layer(geo_layer)
            }
            style={{ display: "inline-block" }}
          >
            <DeleteIcon />
          </div>
        );

        const button_top = mode_map === "editor" && (
          <section style={{ display: "inline-block", gap: "10px" }}>
            {geo_layer_status_that_editable_properties.includes(status) &&
              architecture !== "api" &&
              addRowBulkButton}
            {geo_layer_status_that_editable_layer.includes(status) &&
              editLayerButton}
            {geo_layer_status_that_deleteable.includes(status) &&
            [
              "localhost:3003",
              "dsdajakarta.mapid.io",
              "dsdajakarta-alpha.mapid.io",
              "dsdajakarta-beta.mapid.io",
            ].includes(window.location.hostname) &&
            !["dsdajakarta", "pusdatin_SDA"].includes(
              auth.user?.name?.trim(),
            ) ? (
              <></>
            ) : (
              deleteLayerButton
            )}

            {is_mode_checklist_layer && (
              <div
                onClick={() => handleCheckMarkLayers(_id)}
                className={
                  isIdInsideChecklistLayers(_id)
                    ? "inline_block margin_left checklist_active"
                    : "inline_block margin_left checklist_not"
                }
              ></div>
            )}
          </section>
        );

        const button_footer = (
          <section className="layer_action_section">
            <div
              className="cursor_pointer layer_action_item"
              onClick={() => on_view_layer(geo_layer, !viewStatus, folder_id)}
              data-mapid={`clickTutupMata-${idx}`}
            >
              <ICON_VIEW
                color={viewStatus ? "#000" : "#b7b7b7"}
                strokeWidth={viewStatus ? 4 : 3}
                style={{ width: "27px", height: "27px" }}
              />
              <p
                className={`layer_action_label ${viewStatus ? "active_label" : "inactive_label"}`}
              >
                {dict?.["View"]?.[language]}
              </p>
            </div>

            <div
              className="cursor_pointer layer_action_item"
              onClick={() =>
                on_view_heatmap(geo_layer, !is_view_heatmap, folder_id)
              }
              data-mapid={`clickTutupHitMap-${idx}`}
            >
              <ICON_HEATMAP
                color={is_view_heatmap ? "#000" : "#b7b7b7"}
                strokeWidth={is_view_heatmap ? 4 : 3}
                style={{ width: "27px", height: "27px" }}
              />
              <p
                className={`layer_action_label ${is_view_heatmap ? "active_label" : "inactive_label"}`}
              >
                {dict?.["Heatmap"]?.[language]}
              </p>
            </div>

            {geo_layer_status_that_editable_properties.includes(status) &&
              mode_map === "editor" &&
              architecture !== "api" && (
                <div
                  className="cursor_pointer layer_action_item"
                  onClick={() => toggle_edit_geometry(geo_layer, folder_id)}
                  data-mapid={`clickBukaDigitasi-${idx}`}
                >
                  <ICON_GEOMETRY
                    color={
                      _id === layer_id && geometryStatus ? "#000" : "#b7b7b7"
                    }
                    strokeWidth={_id === layer_id && geometryStatus ? 4 : 3}
                    style={{ width: "27px", height: "27px" }}
                  />
                  <p
                    className={`layer_action_label ${_id === layer_id && geometryStatus ? "active_label" : "inactive_label"}`}
                  >
                    {dict?.["Geometry"]?.[language]}
                  </p>
                </div>
              )}

            <div
              className="cursor_pointer layer_action_item"
              onClick={() => toggle_edit_property(geo_layer, folder_id)}
              data-mapid={`clickBukaTable-${idx}`}
            >
              <ICON_TABLE
                color={_id === layer_id && tableStatus ? "#000" : "#b7b7b7"}
                strokeWidth={_id === layer_id && tableStatus ? 4 : 3}
                style={{ width: "27px", height: "27px" }}
              />
              <p
                className={`layer_action_label ${_id === layer_id && tableStatus ? "active_label" : "inactive_label"}`}
              >
                {dict?.["Table"]?.[language]}
              </p>
            </div>

            <div
              className="cursor_pointer layer_action_item"
              onClick={() => toggle_chat_on_layer(geo_layer)}
            >
              <ICON_CHAT
                color={
                  _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                    ? "#000"
                    : "#b7b7b7"
                }
                strokeWidth={
                  _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                    ? 4
                    : 3
                }
                style={{ width: "27px", height: "27px" }}
              />
              <p
                className={`layer_action_label ${_id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus ? "active_label" : "inactive_label"}`}
              >
                {dict?.["Notes"]?.[language]}
              </p>
            </div>
          </section>
        );

        const type_content = (
          <section>
            {geo_layer?.type === "IoT" ? (
              <section style={{ fontSize: 12, marginBottom: "10px" }}>
                {dict?.["Type"]?.[language]} :
                <div style={{ display: "inline-block", marginLeft: "5px" }}>
                  <b> IoT </b>
                </div>
              </section>
            ) : (
              <section className="badge_small background_grey_light outline_grey">
                {geo_layer?.type}
              </section>
            )}
          </section>
        );

        const migration_content = (
          <div className="margin_top">
            {architecture !== "v2" &&
            architecture !== "api" &&
            process.env.REACT_APP_ARCHITECTURE === "v2" &&
            domain !== "danamas.mapid.io" ? (
              <button
                className="buttonCenter noselect long_button_inactive"
                style={{
                  color: `${viewStatus ? "#ffffff" : "#000000"}`,
                  backgroundColor: `${viewStatus ? "#606f8dff" : "#e5eefdff"}`,
                  width: "100%",
                }}
                onClick={() => {
                  toggleModalMigration();
                  setBodyMigrate({
                    geo_layer_id: _id,
                    user_id: user?._id,
                    geo_project_id: geo_project?._id,
                  });
                }}
              >
                {dict?.["Migration Layer"]?.[language]}
              </button>
            ) : (
              ""
            )}
          </div>
        );

        const final_content = (
          <main>
            <section className="flex margin_bottom">
              <div style={{ flex: 1 }}>{type_content}</div>
              <div className="flex justify_between gap_5">{button_top}</div>
            </section>

            <section>
              <p
                className="text_bold"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                }}
                onClick={() => on_fly_layer(geo_layer, folder_id)}
              >
                {name}
              </p>
            </section>

            <section className="margin_bottom">
              <span className="text_small" style={{ color: "#b7b7b7" }}>
                By{" "}
              </span>
              <span className="text_small">
                {full_name && full_name !== "" && full_name !== "-"
                  ? full_name
                  : username}
              </span>
              <span className="text_small" style={{ color: "#b7b7b7" }}>
                <CIRCLE
                  color={"#dedede"}
                  style={{
                    width: "5px",
                    height: "5px",
                    marginRight: "5px",
                    marginLeft: "5px",
                  }}
                />
                {status}
              </span>
            </section>
            <div
              style={{
                backgroundColor: "transparent",
                borderTop: "2px solid #e6e6e6",
                marginTop: 19,
                marginBottom: 13,
              }}
            />
            {button_footer}
            {migration_content}
          </main>
        );

        let xitai_analytic_button = null;
        if (badge === "xitai") {
          xitai_analytic_button = (
            <Link
              to={{ pathname: "https://regalia-production.up.railway.app/" }}
              target="_blank"
              rel="noopener noreferrer"
              className="button_inactive bg_blue rounded_5 text_white padding_y_2 padding_x_5 font_12 marginLeft_5"
            >
              {dict["Analytics"][language]}
            </Link>
          );
        }

        return (
          <div
            key={_id || idx}
            id={id_css}
            className="layer_box margin_top margin_bottom"
          >
            {final_content}
            {xitai_analytic_button}
          </div>
        );
      })}
    </main>
  );

  const modalEditContent = modalEdit && (
    <Modal
      modalSize="large"
      id="modalEdit"
      isOpen={modalEdit}
      onClose={toggle_edit_general}
      title="Edit Layer"
    >
      <div className="box-body">
        <EditLayer toggle_edit_general={toggle_edit_general} />
      </div>
    </Modal>
  );

  const modalEditorInf = modalEditorInfo && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalEditorInfo}
      onClose={() => handleModalEditorUser()}
    >
      <p style={{ marginBottom: "10px" }}>List Editor </p>
      <div className="box-body">
        <div style={{ display: "flex", flexDirection: "column" }}>
          {editorUsers
            .filter((user) => user.topicId === modalEditorData.idLayer)[0]
            ?.users.map((user) => (
              <div
                key={user._id}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div style={{ marginRight: "10px" }}>
                  <div
                    className={`photo_${user._id}`}
                    style={{
                      height: "60px",
                      width: "60px",
                      borderRadius: "50%",
                      border: `2px solid ${user?.borderColor}`,
                      background: `url(${
                        user.profile_picture.url
                          ? user.profile_picture.url
                          : pic_static
                      }) no-repeat center center / cover`,
                    }}
                  />
                </div>
                <div>
                  <p>{user?.full_name}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Modal>
  );

  const modalDeleteContent = modalDelete && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalDelete}
      onClose={toggle_delete_layer}
      title={dict["Are you sure to delete this layer?"][language]}
    >
      <div className="box-body">
        <DeleteLayer toggle_delete_layer={toggle_delete_layer} />
      </div>
    </Modal>
  );

  const modalDeleteAttachContent = modalDeleteAttach && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalDeleteAttach}
      onClose={toggle_delete_attached_layer}
      title="Konfirmasi hapus"
    >
      <div className="box-body">
        <DeleteLayerAttach toggle_delete_layer={toggle_delete_attached_layer} />
        t
      </div>
    </Modal>
  );

  const modalMigrationContent = modalMigration && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalMigration}
      onClose={toggleModalMigration}
    >
      <main className="flex flex_col gap_20">
        <section className="text_center font_20">
          {dict["Do you really want to migrate this layer to V2?"][language]}
        </section>
        <section className="center_perfect">
          <div className="flex gap_5">
            <button
              className="button button_inactive bg_blue text_white"
              onClick={async () => {
                await migration();
                setModalMigration(false);
              }}
            >
              {dict["Yes"][language]}
            </button>
            <button
              className="button button_inactive background_red text_white"
              onClick={toggleModalMigration}
            >
              {dict["No"][language]}
            </button>
          </div>
        </section>
      </main>
    </Modal>
  );

  return (
    <main>
      {list_content}
      {modalEditContent}
      {modalEditorInf}
      {modalDeleteContent}
      {modalDeleteAttachContent}
      {modalMigrationContent}
      {modal_bounding_box_content}
      {modal_wait_get_layer_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setLayerWOgeojson,
  setChatStatus,
  openModal,
  getDetailLayerById,
  view_layer,
  set_layer_id,
  view_heatmap,
  migration_action,
  set_value_layer,
  get_pda,
  get_pch,
  get_layer_detail_custom_api,
  set_value_toolbox,
  set_value_properties,
})(LayerListRender);
